import { API } from '@Providers';

export default async function (siteId: string) {
  const endpoint = `/api/shelter/kennels/site/${siteId}`;

  return API({ endpoint });
}
